import { AbstractApiService } from "../abstractions/AbstractApiService";
import { OnRequestSuccess, OnRequestError } from "./Responses";
import { ITrainingCourse } from "../models/ITrainingCourse";
import { ITrainingCourseAcceptItem } from "../models/ITrainingCourseAcceptItem";
import { ITrainingCoursesAcceptListFilters } from 'src/models/ITrainingCoursesAcceptListFilters';

export class TrainingCourseService extends AbstractApiService {
    constructor() {
        super();
    }

    public GetMyTrainingCourses(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/trainingcourse/mytrainingcourses', onSuccess, onError);
    }

    public AddMyTrainingCourse(model: ITrainingCourse, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/trainingcourse/addmytrainingcourse', model, onSuccess, onError);
    }

    public RemoveMyTrainingCourse(trainingCourseId: number, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/trainingcourse/removemytrainingcourse', trainingCourseId, onSuccess, onError);
    }

    public GetPhysiotherapistsTrainingCourses(physiotherapistId: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/trainingcourse/getphysiotherspiststrainingcourses?physiotherapistId=' + physiotherapistId, onSuccess, onError);
    }

    public GetAllTrainingCourses(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/trainingcourse/getalltrainingcourses', onSuccess, onError);
    }

    public GetTrainingCoursesForAcceptance(filters: ITrainingCoursesAcceptListFilters, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/trainingcourse/gettrainingcoursesforacceptance', filters, onSuccess, onError);
    }

    public AcceptTrainingCourses(trainingCoursesToAccept: ITrainingCourseAcceptItem[], onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/trainingcourse/accepttrainingcourses', trainingCoursesToAccept, onSuccess, onError);
    }

    public DiscardTrainingCourse(trainingCourseId: number, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/trainingcourse/discardtrainingcourse?trainingCourseId=' + trainingCourseId.toString(), onSuccess, onError);
    }
}


// WEBPACK FOOTER //
// ./src/services/TrainingCourseService.tsx